import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Alert } from '@mui/material';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
} from '@mui/material';

import AutocompleteInput from './AutocompleteInput';

const VariantSelectModal = ({
    open,
    onClose,
    orderItemId,
    hasLimit,
    axiosInstance,
    selectedClient,
    orderData,
    showSnackbar,
    onSuccess,
}) => {
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [existingVariant, setExistingVariant] = useState(null);
    const handleClose = () => {
        if (loading) return;

        setKeyword('');
        setSelectedProduct(null);

        onClose();
    };

    const handleSave = async () => {
        if (!selectedProduct || !orderItemId) {
            showSnackbar('商品を選択してください', 'error');
            return;
        }

        const hasExisting = !!existingVariant?.variant_id;

        if (hasExisting) {
            const ok = window.confirm(
                'すでに紐づいている商品があります。\n変更しますか？\n\nこの処理は取り消せません。'
            );

            if (!ok) return;
        }

        try {
            setLoading(true);

            const res = await axiosInstance.put(
                `order/order-item/${orderItemId}/variant`,
                { variant_id: selectedProduct.variant_id }
            );

            showSnackbar(
                res?.data?.message || '商品を紐付けました',
                'success'
            );

            onSuccess?.(selectedProduct);

            handleClose();
        } catch (err) {
            console.error(err);

            showSnackbar(
                err?.response?.data?.message ||
                '商品の紐付けに失敗しました',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!open || !orderItemId) return;

        const fetchExisting = async () => {
            try {
                const res = await axiosInstance.get(
                    `/order/order-items/${orderItemId}/variant`
                );

                setExistingVariant(res.data);
            } catch (err) {
                console.error(err);
            }
        };

        fetchExisting();
    }, [open, orderItemId]);
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>商品選択</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    {
                        existingVariant?.variant_id && (
                            <Alert severity="info" sx={{ mb: 2 }}>
                                すでに商品データと紐づいています。<br />
                                <Link
                                    to={`/products/${existingVariant?.product_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <Typography
                                        sx={{
                                            color: 'primary.main',
                                            '&:hover': { textDecoration: 'underline' }
                                        }}
                                    >
                                        商品ページ：（{existingVariant?.sku}）
                                        {existingVariant?.product_name}
                                        {existingVariant?.option_combination &&
                                            Object.keys(existingVariant.option_combination).length > 0 &&
                                            ' / ' +
                                            Object.entries(existingVariant.option_combination)
                                                .map(([type, value]) => `(${type}) ${value}`)
                                                .join(' / ')
                                        }
                                    </Typography>
                                </Link>
                            </Alert>
                        )
                    }
                    <AutocompleteInput
                        hasLimit={hasLimit}
                        value={keyword}
                        isEditMode={!loading}
                        fetchSuggestions={async (keyword) => {
                            try {
                                const res = await axiosInstance.post(
                                    '/product/sku_suggest',
                                    {
                                        keyword,
                                        client_id:
                                            selectedClient?.client_id ??
                                            orderData?.client_id ??
                                            null,
                                    }
                                );

                                return res.data;
                            } catch (err) {
                                console.error(err);
                                return [];
                            }
                        }}
                        onChange={(e, idx, product) => {
                            const value =
                                product?.sku ||
                                e?.target?.value ||
                                '';

                            setKeyword(value);

                            if (product) {
                                setSelectedProduct(product);
                            }
                        }}
                        sx={{
                            mt: 1,
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                    disabled={loading}
                >
                    閉じる
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={loading || !selectedProduct}
                >
                    保存
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VariantSelectModal;